import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SystemcodeApi } from "../api-service/system-code/systemcode-api";
import { GroupMsgData} from "../signalr-service";
import { ClinicDataService } from "../data-service/clinic-data-service";
import { EasyNotificationService } from "../easy-notification.service";
import { AuthenticationService } from "src/app/security/services/authentication.service";
import { HcrService } from "../hcr-service.service";
import { UserConfirmService } from "../user-confirm.service";
import { PrintService } from "../print.service";
import { LocalPrintService } from "../local-print.service";

export enum SystemCmd{
  UploadLog='UploadLog',
  UpdateConsole='UpdateConsole',
  PrintReport = 'PrintReport',
  Event = 'Event'
}
@Injectable({
    providedIn: 'root'
  })
export class SystemEventHandler {
    onEvent:EventEmitter<any> = new EventEmitter()
    /**
     *
     */
    constructor(
      private notify:EasyNotificationService,
      private userConfirm:UserConfirmService,
      private hcrService:HcrService,
      private printer:LocalPrintService) {
    }
    /** 執行事件 */
    Invoke(evt:GroupMsgData){
      if(evt.Type=='Action'){                
        this.doAction(evt);
      }else if(evt.Type== 'Notify'){
        this.doNotify(evt);
      }
    }
    /** 動作事件 */
    private doAction(evt:GroupMsgData){
      // if(evt.Act == 'Logout'){
      //   this.auth.logout();
      // }
    }
    private doNotify(evt:GroupMsgData){
      this.notify.showInfo(evt.Arg);
    }
    /** 收到命令 */
    async Command(cmd:string,args:any){
      if(cmd == SystemCmd.UploadLog){
        var sDate:Date = args['SDate'];
        var eDate:Date = args['EDate'];
        if(this.hcrService.ConnectStatus){
          var result = await this.hcrService.UploadLog(sDate,eDate)
          if(result.Successed){
            return `上傳成功 ${result.Returns.Count}筆。\n上傳失敗：\n`
                  + (result.Returns.Failed.length==0 ? '無' 
                      : result.Returns.Failed.concat('...').filter((x,i)=>i<10).join('\n'))
          }else{
            return '執行失敗('+ result.Returns+')';
          }
        }else{
          return '使用者未連接主控台';
        }
      }else if(cmd == SystemCmd.UpdateConsole){
        var cmder = args['Commander'];
        var needAllow = args['NeedAllow'];
        if(needAllow){
          var ret = await this.userConfirm.showConfirm({
            title:'系統更新',
            msg:`${cmder}要求你執行展望主控台更新，是否允許？`
          });
          if(!ret){
            return '使用者拒絕操作';
          }
        }
        if(this.hcrService.ConnectStatus){
          await this.hcrService.Update();
        }else{
          await this.hcrService.openVisionHis();
        }
        return '已嘗試執行更新';
      }else if(cmd == SystemCmd.PrintReport){
        var regId = args['RegId'];
        var reportType = args['Reporttype'];
        await this.printer.printHelper.print(regId,[reportType])
        
        return '已嘗試執行更新';
      }else if(cmd == SystemCmd.Event){
        this.onEvent.emit(args);
      }
      return null;
    }
    
}
